




























































































































































import Vue from "vue";
import { Route } from "vue-router";
import { mapMutations } from "vuex";
export default Vue.extend({
  methods: {
    ...mapMutations(["updateDocument"]),
    formatCtr(ctr: number) {
      if (null === ctr) {
        return "--";
      }
      return Math.round(ctr * 10000) / 100;
    },
    async fetchReportMetrics() {
      const params = {
        month: this.theMonth,
      };

      const res = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.params.id + "/report",
        params,
      ]);
      this.reportMetrics = res["hydra:member"];

      this.loading = false;
    },
    async load() {
      this.loading = true;
      this.reportMetrics = [];
      this.advertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.params.id,
      ]);

      this.fetchReportMetrics();
    },
  },
  watch: {
    $route(to: Route, from: Route) {
      if (to.fullPath !== from.fullPath) {
        this.load();
      }
    },
  },
  mounted() {
    this.load();
  },
  computed: {
    theMonth(): string {
      const queryMonth = "" + (this.$route.query.month || "");
      return queryMonth.match(/^\d\d\d\d-\d\d$/)
        ? queryMonth
        : this.$formatter.dateHyphened(new Date()).substr(0, 7);
    },
    theMonthDate(): Date {
      const [year, month] = this.theMonth.split("-");
      const r = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
      return r;
    },
    prevMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() - 1);
      if (d < new Date(2020, 11, 1)) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
    nextMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() + 1);
      if (new Date() < d) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
  },
  data() {
    return {
      advertisement: {},
      reportMetrics: [],
      page: 1,
      perPage: 50,
      defaultSortOrder: "id",
      sortField: "id",
      sortOrder: "desc",
      total: NaN,
      loading: true,
    };
  },
});
